import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function DifferentlyAbled () {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Facilities for differently abled " />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>Coming Soon..</h3>
                                </div>
                                {/* <p>
                                In accordance with the guidelines of the University Grants Commission (UGC), the Hon'ble
Vice Chancellor of MVN University has constituted the Equal Opportunity Cell (EOC). The
primary objective of this cell is to address issues related to students belonging to Scheduled
Castes (SC), Scheduled Tribes (ST), Other Backward Classes (OBC), Minorities, and Persons
Disabilities (PWDs). The EOC aims to empower these students, ensuring their
participation in the academic, intellectual, social, and cultural life of the University on an
with
equal basis.
                                </p> */}
                            
                               
                               
                              
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DifferentlyAbled